import classNames from 'styles/utils/classNames';

interface Props {
  /** Seats still unfilled. */
  openCount: number;
  /** Total seats in the game. */
  totalCount: number;
  compact?: boolean;
  className?: string;
}

/** Ends an Open Play roster that is too long to show seat by seat. */
export default function OpenSeatsTile({
  openCount,
  totalCount,
  compact = false,
  className,
}: Props) {
  return (
    <div
      className={classNames(
        'flex flex-col items-center justify-center rounded-lg bg-color-bg-lightmode-secondary px-ds-xs py-ds-sm text-center dark:bg-color-bg-darkmode-secondary',
        compact && 'h-full',
        className,
      )}
    >
      <span className="typography-product-subheading-mobile text-color-text-brand">
        {openCount}/{totalCount}
      </span>
      <span className="typography-product-caption text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
        open
      </span>
    </div>
  );
}
